import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import cloneDeep from 'lodash/cloneDeep';

import * as equipment from '~/misc/equipment';
import DropDown from '../DropDown';
import LabeledInput from '../LabeledInput';
import {MenuList, MenuListItem} from '../MenuList';
import KEYS from '~/misc/keys';

import css from './index.css';

const dataQa = (prefix, postfix) => {
  if (!prefix) {
    return null;
  }
  return `${prefix}-eqsel-${postfix}`;
};

const otherIsNeeded = (value) => value.some(item => equipment.newIdToHumanOther[item]);

const ItemsList = ({value, values, limit, prefix, handleToggle, handleRadio, isRadio}) =>
  (<div>
    {values.map(i => {
      const full = limit ? (value.length === limit) : false;
      const selected = value.includes(i);
      const disabled = full && !isRadio && !selected;
      const fn = !disabled && (isRadio ? handleRadio : handleToggle)
      let props = {
        data: i,
        title: equipment.idToFull[i],
        selected: selected,
        disabled: disabled,
        fn: fn,
        multi: true,
      };

      return (
        <MenuListItem
          {...props}
          key={i}
          data-qa={dataQa(prefix, `item-${i.toLowerCase()}`)}
        />);
    })}
  </div>);

class EquipSelect extends React.Component {
  constructor(props) {
    super(props);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleRadio = this.handleRadio.bind(this);
    this.handleAny = this.handleAny.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.showVisible = this.showVisible.bind(this);
  }

  componentWillMount() {
    this.setState({otherIsWanted: otherIsNeeded(this.props.value)});
  }

  componentWillReceiveProps(nextProps) {
    if (((nextProps.dropdownOpened !== this.props.dropdownOpened) || (nextProps.value !== this.props.value))
      && !nextProps.dropdownOpened && !otherIsNeeded(this.props.value)) {
      this.setState({otherIsWanted: false});
    }
  }

  render() {
    const prefix = this.props['data-qa'];
    const props = this.props;
    let value = cloneDeep(props.value || props.initialValue);
    value = value.filter(item => equipment.newInputValuesAll.indexOf(item) !== -1)
    const defaultValue = this.props.withoutAny ? [] : ['Any'];
    
    return (
      <div className={cs(css.wrap, props.wrapClassName)}>
        <DropDown
          data-qa={dataQa(prefix, 'dropdown')}
          id={props.dropDownId}
          wrapClassName={css.dropdown}
          trigger={
            <LabeledInput
              {...this.props.input}
              data-qa={dataQa(prefix, 'input')}
              label={props.isNotEquipmentLabel ? '' : 'Equipment'}
              value={value.length ? value : defaultValue}
              icon='plus'
              tags={true}
              readOnly={true}
              placeholder={props.placeholder}
            />
          }
          content={this.renderSelect()}
          onKeyPress={this.onKeyPress}
        />
      </div>
    );
  }

  renderSelect() {
    const value = this.props.value || this.props.initialValue;
    const values = Object.keys(this.props.values || equipment.newIdToHumanMain);
    const prefix = this.props['data-qa'];

    return (
      <div className={cs(css.dropdownContent)}>
        <MenuList multi={true}>
          {this.props.withoutAny ? null : (<MenuListItem
            fn={this.handleAny}
            title='Any'
            selected={!value.length}
            data-qa={dataQa(prefix, 'item-any')}
          />)}
          <ItemsList
            value={value}
            values={values}
            limit={this.props.limit}
            prefix={prefix}
            handleToggle={this.handleToggle}
            handleRadio={this.handleRadio}
            isRadio={this.props.isRadio}
          />
          {this.renderOther(value, prefix)}
        </MenuList>
      </div>
    );
  }

  renderOther(value, prefix) {
    if (this.props.values) {
      return null;
    }

    const otherIsVisible = (this.state && this.state.otherIsWanted) || otherIsNeeded(value) || null;

    return (
      <div>
        {otherIsVisible ? null : <MenuListItem title='Other' fn={this.showVisible} className='qa-other'/>}
        {otherIsVisible && (
          <ItemsList
            value={value}
            values={Object.keys(equipment.newIdToHumanOther)}
            limit={this.props.limit}
            prefix={prefix}
            handleToggle={this.handleToggle}
            handleRadio={this.handleRadio}
            isRadio={this.props.isRadio}
          />
        )}
      </div>
    );
  }

  handleAny() {
    this.props.onChange([]);
  }

  onKeyPress(keyCode) {
    if (keyCode !== KEYS.BKSP) {
      return false;
    }
    const value = this.props.value || this.props.initialValue;
    if (value.length) {
      this.props.onChange(value.slice(0, -1));
    }
    return !value.length;
  }

  handleRadio(e) {
    const toggledValue = e.currentTarget.getAttribute('data-value');
    const value = this.props.value || this.props.initialValue;
    if (!value.includes(toggledValue)) {
      this.props.onChange([toggledValue])
    }
  }
  handleToggle(e) {
    const toggledValue = e.currentTarget.getAttribute('data-value');
    const value = this.props.value || this.props.initialValue;
    if (value.includes(toggledValue)) {
      this.props.onChange(value.filter(i => i !== toggledValue));
    } else {
      this.props.onChange([...value, toggledValue]);
    }
  }

  showVisible() {
    this.setState({otherIsWanted: true});
  }
}

export default connect((state, props) => ({dropdownOpened: Boolean(state.dropdowns[props.dropDownId])}))(EquipSelect);



// WEBPACK FOOTER //
// ./src/components/common/EquipSelect2/index.js